/**
 * Detect "touch-first mobile" (phone or tablet) via `navigator.maxTouchPoints`.
 *
 * The `> 1` threshold filters out single-point-touch desktop monitors
 * that report a touch capability they can't actually use.
 */
export function getIsMobileDevice(): boolean {
  if (typeof navigator === 'undefined') return false
  return (navigator.maxTouchPoints ?? 0) > 1
}
